import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TOKEN_KEY = 'hwc_admin_token';

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (token) => localStorage.setItem(TOKEN_KEY, token);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);
export const isAuthenticated = () => Boolean(getToken());

const authHeaders = () => ({
  headers: { Authorization: `Bearer ${getToken()}` },
});

export const login = async (email, password) => {
  const res = await axios.post(`${API}/auth/login`, { email, password });
  setToken(res.data.access_token);
  return res.data.user;
};

export const fetchMe = async () => {
  const res = await axios.get(`${API}/auth/me`, authHeaders());
  return res.data;
};

export const fetchPosts = async () => {
  const res = await axios.get(`${API}/blog`);
  return res.data;
};

export const fetchAdminPosts = async () => {
  const res = await axios.get(`${API}/admin/blog`, authHeaders());
  return res.data;
};

export const fetchAdminPost = async (slug) => {
  const res = await axios.get(`${API}/admin/blog/${slug}`, authHeaders());
  return res.data;
};

export const uploadImage = async (file) => {
  const data = new FormData();
  data.append('file', file);
  const res = await axios.post(`${API}/upload`, data, {
    headers: {
      Authorization: `Bearer ${getToken()}`,
      'Content-Type': 'multipart/form-data',
    },
  });
  // Return an absolute URL so it renders everywhere
  return `${process.env.REACT_APP_BACKEND_URL}${res.data.url}`;
};

export const fetchPost = async (slug) => {
  const res = await axios.get(`${API}/blog/${slug}`);
  return res.data;
};

export const createPost = async (payload) => {
  const res = await axios.post(`${API}/blog`, payload, authHeaders());
  return res.data;
};

export const updatePost = async (slug, payload) => {
  const res = await axios.put(`${API}/blog/${slug}`, payload, authHeaders());
  return res.data;
};

export const deletePost = async (slug) => {
  const res = await axios.delete(`${API}/blog/${slug}`, authHeaders());
  return res.data;
};

export const fetchLeads = async () => {
  const res = await axios.get(`${API}/contact`, authHeaders());
  return res.data;
};

export const updateLeadStatus = async (leadId, status) => {
  const res = await axios.patch(`${API}/contact/${leadId}/status`, { status }, authHeaders());
  return res.data;
};
